<template>
    <section>
        <div class="page">
            <div>
                <h2>How to update ToTok</h2>
                <p>
                    You can easily update ToTok from your phone's app store. Please note if you received a message that
                    isn't
                    supported by your version of ToTok, you app will need updated.
                </p>
                <h3>
                    To update ToTok
                </h3>
                <ul>
                    <li>
                        Go to Play Store, then tap Menu > My apps & games. Tap <strong>UPDATE</strong> next to ToTok
                        Messenger.
                    </li>
                    <li>
                        Alternatively, go to Play Store and search for ToTok. Tap <strong>UPDATE</strong> under ToTok
                        Messenger.
                    </li>
                </ul>
                <p>
                    We encourage you to always use the latest version of ToTok. Latest versions contain the newest
                    features and bug
                    fixes.
                </p>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
